<template>
  <div class="mm_body">
    <mmheader :mm-site-url="mm_site_url"></mmheader>
    <div style="clear: both;"></div>
    <section class="container" style="padding-top: 72px !important;">
      <div class="row justify-content-center mb-3">
        <div class="col-md-5 col-xs-12">
          <div class="mt-5 mb-4 text-center">
            <flash-message autoHide variant="success"></flash-message>
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged"
              >
              {{ success_message }}
            </b-alert>
            <b-alert
              :show="dismissCountWarningDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountWarningDown=0"
              @dismiss-count-down="countDownWarningChanged"
              >
              {{ warning_message }}
            </b-alert>
          </div>

          <div class="text-center" style="margin-bottom: 4rem !important;">
            <div class="h4 font-weight-bold">Please Verify Your Email Address</div>
          </div>

          <!-- <div v-if="editFlag == false" class="input-group email_update_box mb-3 col">
            <div class="col-11 p-0" style="font-size: 16px;">
            {{ email }}
            </div>
              <div class="col-1 input-group-append text-align-right">
                <span class="input-group-text" style="background: none;border: none;color: #b2b2b2;">
                <i @click="editFlag = true" class="fa fa-pencil" aria-hidden="true" style="cursor: pointer;"></i>
                </span>
              </div>
          </div>


          <div v-if="editFlag == true" class="input-group email_update_box mb-3" style="border: 0;">
            <input 
              type="text" 
              name="email" 
              id="email" 
              ref="email"
              v-validate="{ rules: { required: true, email: true } }" 
              maxlength="250" 
              v-model="email"
              class="form-control" 
              placeholder="Email">
              <div class="input-group-append">
                <button type="submit" class="btn btn-md btn-blue text-center" @click="saveEmail()">Save</button>
              </div>
            <div v-if="verrors.firstByRule('email', 'required')" class="margin-bottom-5 validate-warning-msg">The
              email field is required</div>
            <div v-if="verrors.firstByRule('email', 'email')" class="margin-bottom-5 validate-warning-msg">The email
              field must be a valid email</div>
          </div> -->


          <div class="mb-5">
            <SimpleOtpInput 
              v-model="code"
              :inputProps="{
                type: 'number',
                min: 0,
              }" 
              @change="handleChange"/>
          </div>

          <div class="text-center mt-3">
            <button type="submit" class="btn btn-lg text-center px-5" @click="verifyCode()" :disabled="disable_verify_btn" :class="disable_verify_btn ? 'btn-blue-disabled' : 'btn-blue'">Verify Email</button>
          </div>

          <div class="text-center mt-2">
            <a class="font-weight-bold" style="cursor: pointer; color: #002F42;" @click="resendCode()">Resend Code</a>
          </div>

        </div>
      </div>    
    </section>
    <mmfooter :mm-site-url="mm_site_url"></mmfooter>
  </div>
</template>

<script>
import SimpleOtpInput from "vue-simple-otp-input";
import 'vue-simple-otp-input/dist/vue-simple-otp-input.css';
import mmheader from '@/components/mm_header';
import mmfooter from '@/components/mm_footer';
import axios from 'axios';

export default {
  data() {
    return {
      mm_site_url: process.env.MM_SITE_URL,
      email: '',
      editFlag: false,
      success_message: '',
      warning_message: '',
      dismissCountDown: 0,
      dismissCountWarningDown: 0,
      code: '',
      disable_verify_btn: true,
    }
  },
  components: {
    SimpleOtpInput,
    mmheader,
    mmfooter,
  },

  methods: {
    handleChange(v) {
      if(v.trim().length == 6) {
        this.disable_verify_btn = false;
      } else {
        this.disable_verify_btn = true;
      }
    },
    verifyCode() {
      if(this.code == '') {
        alert("Please enter the verification code");
        return false;
      }
      else if(this.code.length != 6) {
        alert("Verification code should be 6 digit");
        return false;
      }
      else {
        this.disable_verify_btn = true;
            axios('/custom/verify-code',
            {
                method: 'POST',
                data: {
                  uid: this.$store.state.create_account_uid,
                  code: this.code,
                  accountId: this.$store.state.create_account_accountId,
                }
            })
            .then(response => {  
              this.flash({ message: "Account verified successfully!", variant: 'success' });              
              this.$router.push({ name: 'mmCreateAccountSubscriptionLists'})
            })
            .catch(error => {
              this.warning_message = 'Invalid verification code.';
              this.dismissCountWarningDown = 5;
              this.code = '';
            });
      }

    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownWarningChanged(dismissCountWarningDown) {
      this.dismissCountWarningDown = dismissCountWarningDown
    },
    resendCode: function() {
      axios('/custom/resend-code/' + this.email + '/' + this.$store.state.create_account_uid,
      {
          method: 'GET', 
      })
      .then(response => {                
        this.success_message = 'Verification code resend successfully.';
        this.dismissCountDown = 5;
      })
      .catch(error => {
      });

    },
    saveEmail: function() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          console.log("ERROR" + result)
          console.log(this.verrors);
          return;
        }
        else {
          this.editFlag = false;
          let uid = this.$store.state.create_account_uid;
          let accountId = this.$store.state.create_account_accountId;
          let email = this.email;
          this.$store.dispatch('create_account', { uid, accountId, email })

        }

      }).catch(() => {
        // catches the error;
      });

    },
  },

  created() {
    this.email = this.$store.state.create_account_email;
    if(!this.$store.state.create_account_email) {
      this.$router.push({ name: 'mmcreateaccount'})
    }

  },
}
</script>

<style scoped>
.mm_body {
  /* font-size: 20px !important; */
  color: #002F42;
  max-width: 2400px;
  margin: auto;
  font-family: "proxima-nova", Arial, verdana !important;
}
.btn-blue {
  font-size: 18px;
  padding: 2px 30px 2px 30px;
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  border-radius: 5px;
}
.btn-blue:hover {
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
}
.btn-blue-disabled {
  font-size: 18px;
  padding: 2px 30px 2px 30px;
  background-color: #b8b8b8 !important;
  border: 1px solid #b8b8b8 !important;
  border-radius: 5px;
  color: white;
}
.btn-blue-disabled:hover {
  color: white;
  background-color: #b8b8b8 !important;
  border: 1px solid #b8b8b8 !important;
}
.alert-success {
  background: #3dce7b;
  color: white;
  font-weight: bold;
  font-size: 16px;
}

/deep/ .alert-success button.close {
  color: white !important;
  opacity: 1;
  font-weight: normal;
}
.email_update_box {
  border-bottom: 1px solid #e9e9e9;
}
.email_update_box input {
  margin-right: 15px;
}
.email_update_box input:focus {
  box-shadow: none;
}
.email_update_box .input-group-text {
  background: none;
  border: none;
  color: #b2b2b2;
}

/* verify code css */
/deep/ .otp-single-input {
  width: 64px;
  height: 64px;
  font-size: 32px;
  border-radius: 7px;
  border: 1px solid #ced4da;
  font-weight: bold;
}
/deep/ .single-input-container {
  margin: 0px 6px;
}

/deep/ input.otp-single-input[type="number"] {
  -moz-appearance: textfield;
}

/deep/ input.otp-single-input[type="number"]::-webkit-outer-spin-button,
/deep/ input.otp-single-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ input.otp-single-input[type="number"] {
  appearance: textfield;
}
/* media query css start */
@media (max-width: 760px) {
/deep/ .single-input-container {
  margin: 0px 2px;
}
}

</style>


// WEBPACK FOOTER //
// src/components/create_account/verify.vue